import lazyRender from 'components/LazyRender';

const staticEditModalList = {
	'/static/band': lazyRender(() => import('static-solutions/24155/identity-solution/band/BandEditModal')),
	'/static/function': lazyRender(() => import('static-solutions/24155/identity-solution/function-master/FunctionEditModal')),
	'/static/position': lazyRender(() => import('static-solutions/24155/identity-solution/position-master/PositionEditModal')),
	'/static/leave-policy': lazyRender(() => import('static-solutions/24155/policy-solution/leave/LeaveEditModal')),
	'/static/attendance-shift': lazyRender(() => import('static-solutions/24155/policy-solution/shift/ShiftEditModal')),
	'/static/process-role': lazyRender(() => import('static-solutions/24155/identity-solution/processrole-master/ProcessRoleEditModal')),
	'/static/shift-assignment': lazyRender(() => import('static-solutions/24155/policy-solution/attendance/AttendanceEditModal')),
	'/static/document-group': lazyRender(() => import('static-solutions/24155/identity-solution/document-group/DocumentGroupEditModal')),
	'/static/access-control': lazyRender(() => import('static-solutions/24155/identity-solution/access-control/AccessControlEditModal')),
	'/static/control-testing': lazyRender(() => import('static-solutions/24155/identity-solution/control-testing/ControlTestingEditModal')),
	'/static/compliance-action': lazyRender(() => import('static-solutions/24155/identity-solution/action-repository/ActionRepositoryEditModal')),
	'/static/management-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/management-hierarchy/ManagementHierarchyEditModal')
	),
	'/static/control-questionnaire': lazyRender(
		() => import('static-solutions/24155/identity-solution/control-questionnaire/ControlQuestionnaireEditModal')
	),
	'/static/performance-parameter': lazyRender(
		() => import('static-solutions/24155/identity-solution/performanceParameter/PerformanceParameterModal')
	),
	'/static/assign-control-self-assurance': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance/AssignControlForSelfAssuranceEditModal')
	),
	'/static/assign-control-self-assurance-v2': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/AssignControlForSelfAssuranceV2EditModal')
	),
	'/static/key-management-area': lazyRender(() => import('static-solutions/24155/identity-solution/key-management-area/KeyManagementEditModal')),
	'/static/wht-section': lazyRender(() => import('static-solutions/24155/identity-solution/wht-section/WhtSectionEditModal')),
	'/static/wht-rate-card': lazyRender(() => import('static-solutions/24155/policy-solution/wht-rate-card/WhtRateCardEditModal')),
	'/static/tax-card': lazyRender(() => import('static-solutions/24155/policy-solution/tax-card/TaxCardEditModal')),
	'/static/vat-card': lazyRender(() => import('static-solutions/24155/policy-solution/vat-card/VatCardEditModal')),
	'/static/wht-code': lazyRender(() => import('static-solutions/24155/identity-solution/wht-code/WhtCodeEditModal')),
	'/static/services': lazyRender(() => import('static-solutions/24155/identity-solution/services/ServiceEditModal')),
	'/static/service-category-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/service-category-master/ServiceCategoryMasterEditModal')
	),
	'/static/materials': lazyRender(() => import('static-solutions/24155/identity-solution/materials/MaterialEditModal')),
	'/static/item-master': lazyRender(() => import('static-solutions/24155/identity-solution/item-master/ItemMasterEditModal')),
	'/static/service-master': lazyRender(() => import('static-solutions/24155/identity-solution/service-master/ServiceMasterEditModal')),
	'/static/warehouse-location-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/warehouse-location-master/WarehouseLocationMasterEditModal')
	),
	'/static/currency-master': lazyRender(() => import('static-solutions/24155/identity-solution/currency-master/CurrencyMasterEditModal')),
	'/static/tax-exemption': lazyRender(() => import('static-solutions/24155/policy-solution/tax-exemption/TaxExemptionEditModal')),
	'/static/asset-accounts-assignment': lazyRender(
		() => import('static-solutions/24155/policy-solution/asset-accounts-assignment/AssetAccountAssignmentEditModal')
	),
	'/static/parent-material': lazyRender(() => import('./24155/identity-solution/accounting-group/AccountingGroupEditModal')),
	'/static/cost-object-type': lazyRender(() => import('./24155/identity-solution/cost-object-type/CostObjectTypeEditModal')),
	'/static/goods-movement-type': lazyRender(() => import('./24155/identity-solution/goods-movement-type/GoodMovementTypeEditModal')),
	'/static/warehouse-master': lazyRender(() => import('./24155/identity-solution/warehouse-master/WarehouseMasterEditModal')),
	'/static/uom-master': lazyRender(() => import('./24155/identity-solution/uom-master/UomMasterEditModal')),
	'/static/vendor-master': lazyRender(() => import('./24155/identity-solution/vendor-master/VendorMasterEditModal')),
	'/static/payment-terms-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterEditModal')
	),
	'/static/automatic-accounting-rules': lazyRender(
		() => import('./24155/policy-solution/automatic-accounting-rules/AutomaticAccountingRuleEditModal')
	),
	'/static/document-type': lazyRender(() => import('./24155/identity-solution/document-type/DocumentTypeEditModal')),
	'/static/process-group-roles': lazyRender(() => import('./24155/identity-solution/process-group-roles/ProcessGroupRolesEditModal')),
	'/static/allowance': lazyRender(() => import('./24155/identity-solution/allowances/AllowanceEditModal')),
	'/static/pay-scale-group': lazyRender(() => import('static-solutions/24155/identity-solution/pay-scale-group/PayScaleGroupEditModal')),
	'/static/compensation': lazyRender(() => import('static-solutions/24155/identity-solution/compensation/CompensationEditModal')),
	'/static/tax-rule': lazyRender(() => import('static-solutions/24155/policy-solution/tax-rule/TaxRuleEditModal')),
	'/static/performance-rule': lazyRender(() => import('static-solutions/24155/identity-solution/performanceRule/PerformanceRuleEditModal')),
	'/static/shift-design': lazyRender(() => import('static-solutions/24155/policy-solution/shift-design/ShiftDesignEditModal')),
	'/static/lead-sla': lazyRender(() => import('static-solutions/24155/identity-solution/lead-sla/LeadSlaEditModal')),
	'/static/lead-sla-configuration': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-sla-configuration/LeadSlaConfigurationEditModal')
	),
	'/static/lead-product': lazyRender(() => import('static-solutions/24155/identity-solution/lead-product/LeadProductEditModal')),
	'/static/technical-evaluation-criteria-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/technical-evaluation-criteria-master/TechnicalEvaluationCriteriaMasterEditModal')
	),
	'/static/lead-stages': lazyRender(() => import('static-solutions/24155/identity-solution/lead-stages/LeadStagesEditModal')),
	'/static/lead-stage-definition-v2': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-definition-v2/LeadStageDefinitionV2EditModal')
	),
	'/static/lead-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-profile-rules/LeadStageProfileRulesEditModal')
	),
	'/static/industry': lazyRender(() => import('static-solutions/24155/identity-solution/industry/IndustryEditModal')),
	'/static/item-category-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/item-category-master/ItemCategoryMasterEditModal')
	),
	'/static/rate-card-entry': lazyRender(() => import('static-solutions/24155/identity-solution/rate-card-entry/RateCardEntryEditModal')),

	'/static/pre-litigation-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matters-type/PreLitigationMattersTypeEditModal')
	),
	'/static/recruitment-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/recruitment-matters-type/RecruitmentMattersTypeEditModal')
	),
	'/static/litigation-type': lazyRender(() => import('static-solutions/24155/identity-solution/litigation-type/LitigationTypeEditModal')),
	'/static/procurement-type': lazyRender(() => import('static-solutions/24155/identity-solution/procurement-type/ProcurementTypeEditModal')),
	'/static/pre-litigation-litigation-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-type/LitigationTypeEditModal')
	),
	'/static/pre-litigation-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stage-profile-rules/PreLitigationStageProfileRulesEditModal')
	),
	'/static/pre-litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stages-hierarchy/PreLitigationStagesHierarchyEditModal')
	),
	'/static/recruitment-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/recruitment-stages-hierarchy/RecruitmentStagesHierarchyEditModal')
	),
	'/static/litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-stages-hierarchy/LitigationStagesHierarchyEditModal')
	),
	'/static/litigation-stage-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-stages-hierarchy/LitigationStagesHierarchyEditModal')
	),
	'/static/supply-chain-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/supply-chain-stages-hierarchy/SupplyChainStagesHierarchyEditModal')
	),
	'/static/supply-chain-stage-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/supply-chain-stages-hierarchy/SupplyChainStagesHierarchyEditModal')
	),
	'/static/legal-action-performance-manager': lazyRender(
		() => import('static-solutions/24155/identity-solution/legal-action-performance-manager/LegalActionPerformanceManagerEditModal')
	),
};

export const staticCreateModalList = {
	'/static/band': lazyRender(() => import('static-solutions/24155/identity-solution/band/BandCreateModal')),
	'/static/function': lazyRender(() => import('static-solutions/24155/identity-solution/function-master/FunctionCreateModal')),
	'/static/position': lazyRender(() => import('static-solutions/24155/identity-solution/position-master/PositionCreateModal')),
	'/static/wht-code': lazyRender(() => import('static-solutions/24155/identity-solution/wht-code/WhtCodeCreateModal')),
	'/static/wht-section': lazyRender(() => import('static-solutions/24155/identity-solution/wht-section/WhtSectionCreateModal')),
	'/static/wht-rate-card': lazyRender(() => import('static-solutions/24155/policy-solution/wht-rate-card/WhtRateCardCreateModal')),
	'/static/tax-card': lazyRender(() => import('static-solutions/24155/policy-solution/tax-card/TaxCardCreateModal')),
	'/static/vat-card': lazyRender(() => import('static-solutions/24155/policy-solution/vat-card/VatCardCreateModal')),
	'/static/process-role': lazyRender(() => import('static-solutions/24155/identity-solution/processrole-master/ProcessRoleCreateModal')),
	'/static/control-testing': lazyRender(() => import('static-solutions/24155/identity-solution/control-testing/ControlTestingCreateModal')),
	'/static/key-management-area': lazyRender(() => import('static-solutions/24155/identity-solution/key-management-area/KeyManagementCreateModal')),
	'/static/compliance-action': lazyRender(() => import('static-solutions/24155/identity-solution/action-repository/ActionRepositoryCreateModal')),
	'/static/management-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/management-hierarchy/ManagementHierarchyCreateModal')
	),
	'/static/control-questionnaire': lazyRender(
		() => import('static-solutions/24155/identity-solution/control-questionnaire/ControlQuestionnaireCreateModal')
	),
	'/static/assign-control-self-assurance': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance/SelfAssuranceCreateModal')
	),
	'/static/assign-control-self-assurance-v2': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/SelfAssuranceCreateV2Modal')
	),
	'/static/services': lazyRender(() => import('static-solutions/24155/identity-solution/services/ServiceCreateModal')),
	'/static/service-category-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/service-category-master/ServiceCategoryMasterCreateModal')
	),
	'/static/materials': lazyRender(() => import('static-solutions/24155/identity-solution/materials/MaterialCreateModal')),
	'/static/item-master': lazyRender(() => import('static-solutions/24155/identity-solution/item-master/ItemMasterCreateModal')),
	'/static/service-master': lazyRender(() => import('static-solutions/24155/identity-solution/service-master/ServiceMasterCreateModal')),
	'/static/warehouse-location-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/warehouse-location-master/WarehouseLocationMasterCreateModal')
	),
	'/static/currency-master': lazyRender(() => import('static-solutions/24155/identity-solution/currency-master/CurrencyMasterCreateModal')),
	'/static/tax-exemption': lazyRender(() => import('static-solutions/24155/policy-solution/tax-exemption/TaxExemptionCreateModal')),
	'/static/asset-accounts-assignment': lazyRender(
		() => import('static-solutions/24155/policy-solution/asset-accounts-assignment/AssetAccountAssignmentCreateModal')
	),
	'/static/parent-material': lazyRender(() => import('./24155/identity-solution/accounting-group/AccountingGroupCreateModal')),
	'/static/cost-object-type': lazyRender(() => import('./24155/identity-solution/cost-object-type/CostObjectTypeCreateModal')),
	'/static/goods-movement-type': lazyRender(() => import('./24155/identity-solution/goods-movement-type/GoodMovementTypeCreateModal')),
	'/static/warehouse-master': lazyRender(() => import('./24155/identity-solution/warehouse-master/WarehouseMasterCreateModal')),
	'/static/uom-master': lazyRender(() => import('./24155/identity-solution/uom-master/UomMasterCreateModal')),
	'/static/vendor-master': lazyRender(() => import('./24155/identity-solution/vendor-master/VendorMasterCreateModal')),
	'/static/payment-terms-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterCreateModal')
	),
	'/static/automatic-accounting-rules': lazyRender(
		() => import('./24155/policy-solution/automatic-accounting-rules/AutomaticAccountingRuleCreateModal')
	),
	'/static/document-type': lazyRender(() => import('./24155/identity-solution/document-type/DocumentTypeCreateModal')),
	'/static/compensation': lazyRender(() => import('static-solutions/24155/identity-solution/compensation/CompensationCreateModal')),
	'/static/allowance': lazyRender(() => import('./24155/identity-solution/allowances/AllowanceCreateModal')),
	'/static/pay-scale-group': lazyRender(() => import('static-solutions/24155/identity-solution/pay-scale-group/PayScaleGroupCreateModal')),
	'/static/tax-rule': lazyRender(() => import('static-solutions/24155/policy-solution/tax-rule/TaxRuleCreateModal')),
	'/static/performance-rule': lazyRender(() => import('static-solutions/24155/identity-solution/performanceRule/PerformanceRuleCreateModal')),
	'/static/shift-design': lazyRender(() => import('static-solutions/24155/policy-solution/shift-design/ShiftDesignCreateModal')),
	'/static/shift-assignment': lazyRender(() => import('static-solutions/24155/policy-solution/attendance/AttendanceCreateModal')),
	'/static/lead-sla': lazyRender(() => import('static-solutions/24155/identity-solution/lead-sla/LeadSlaCreateModal')),
	'/static/lead-sla-configuration': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-sla-configuration/LeadSlaConfigurationCreateModal')
	),
	'/static/lead-product': lazyRender(() => import('static-solutions/24155/identity-solution/lead-product/LeadProductCreateModal')),
	'/static/technical-evaluation-criteria-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/technical-evaluation-criteria-master/TechnicalEvaluationCriteriaMasterCreateModal')
	),
	'/static/lead-stages': lazyRender(() => import('static-solutions/24155/identity-solution/lead-stages/LeadStagesCreateModal')),
	'/static/lead-stage-definition-v2': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-definition-v2/LeadStageDefinitionV2CreateModal')
	),
	'/static/lead-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-profile-rules/LeadStageProfileRulesCreateModal')
	),
	'/static/industry': lazyRender(() => import('static-solutions/24155/identity-solution/industry/IndustryCreateModal')),
	'/static/item-category-master': lazyRender(
		() => import('static-solutions/24155/identity-solution/item-category-master/ItemCategoryMasterCreateModal')
	),
	'/static/rate-card-entry': lazyRender(() => import('static-solutions/24155/identity-solution/rate-card-entry/RateCardEntryCreateModal')),

	'/static/pre-litigation-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matters-type/PreLitigationMattersTypeCreateModal')
	),
	'/static/recruitment-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/recruitment-matters-type/RecruitmentMattersTypeCreateModal')
	),
	'/static/litigation-type': lazyRender(() => import('static-solutions/24155/identity-solution/litigation-type/LitigationTypeCreateModal')),
	'/static/procurement-type': lazyRender(() => import('static-solutions/24155/identity-solution/procurement-type/ProcurementTypeCreateModal')),
	'/static/pre-litigation-litigation-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-type/LitigationTypeCreateModal')
	),
	'/static/pre-litigation-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stage-profile-rules/PreLitigationStageProfileRulesCreateModal')
	),
	'/static/pre-litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stages-hierarchy/PreLitigationStagesHierarchyCreateModal')
	),
	'/static/recruitment-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/recruitment-stages-hierarchy/RecruitmentStagesHierarchyCreateModal')
	),
	'/static/litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-stages-hierarchy/LitigationStagesHierarchyCreateModal')
	),
	'/static/litigation-stage-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/litigation-stages-hierarchy/LitigationStagesHierarchyCreateModal')
	),
	'/static/supply-chain-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/supply-chain-stages-hierarchy/SupplyChainStagesHierarchyCreateModal')
	),
	'/static/supply-chain-stage-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/supply-chain-stages-hierarchy/SupplyChainStagesHierarchyCreateModal')
	),
	'/static/legal-action-performance-manager': lazyRender(
		() => import('static-solutions/24155/identity-solution/legal-action-performance-manager/LegalActionPerformanceManagerCreateModal')
	),
};

export default staticEditModalList;
